<template>
  <div>
    <div id="package" class="flex-container">
      <div class="yasashikute_item illust">
        <h2>
          <img width="520" src="../assets/title1@2x.png" alt="優しくて濃厚なパッケージ">
        </h2>
        <!--<img width="614" src="../assets/yasashikute-noukouna-package@2x.png"/>-->
        <!--<img class="illustrationBy" width="281" src="../assets/illustrationbyhiroshinagai@2x.png"/>-->
      </div>
      <div class="yasashikute_item text">
        <p class="main">
          五島の景色や風土は、やさしくて濃厚です。美しい海を吹き抜けていく風のやさしさを感じたかと思えば、濃厚な文化を感じることもできる。島のそんな雰囲気をパッケージで味わっていただきたいと考え、永井博さんにイラストを描いていただきました。<br>
          <br>
          これまで海外の海を描くことが多かった永井さんに、魚津ヶ崎公園からのぞむ海をリクエスト。朝日が差し込む部屋でポタージュを食べながら、五島の海を思い出していただければ幸いです。
        </p>
        <dl>
          <dt>永井博</dt>
          <dd>
            1970年よりグラフィックデザイナーとしての仕事を始める。<br>
            1980年代以降大瀧詠一の<span class="text">『A LONG VACATION』、</span><span class="text">『NIAGARA SONG BOOK』等</span>のレコードジャケットに代表されるトロピカルでクリアな風景イラストレーションを手がける。『A LONG VACATION』のジャケットは、CBSソニーより「アルバムジャケット特別賞」としてゴールドディスクを受賞している。<br>
大瀧のレコードジャケットによって独自の地位を築き、その他、サザンオールスターズ、松岡直也、石黒ケイ、藤原ヒロシと川辺ヒロシ、憂歌団、杉山清貴など、多くのアーティストのレコード・CDジャケットを飾る。近年ではAORのコンピレーション『breeze』シリーズ、ikkubaru『Amusement Park』、『brighter』、TEEN RUNNINGS『NOW』、サニーデイ・サービス『DANCE TO YOU』のジャケットのアートワークを担当。またZoffの2016年サングラスキャンペーンやSUBARU WRX S4のテレビCMでもイラストが起用された。 
          </dd>
        </dl>
      </div>
    </div>
    <div id="themesong" class="flex-container type2">
      <div class="yasashikute_item illust type2">
        <h2 class="i2">
          <img width="550" src="../assets/title3@2x.png" alt="優しくて濃厚なテーマソング">
        </h2>
        <!--<img width="536" src="../assets/yasashikute-noukouna-themesong@2x.png"/>-->
        
        <div class="musicBox">
          <div>
            試聴・DLはこちら
            <a href="https://smej.lnk.to/GOTO" target="_blank"><img src="../assets/goto_music.jpg" alt=""></a>
          </div>
          <div>
            OFFICIAL SITE
            <a href="http://tokyohealthclub.com/" target="_blank"><img src="../assets/thc_1@2x.png" alt=""></a>
          </div>
        </div>
      </div>
      <div class="yasashikute_item text type2">
        <p class="main">
          五島やポタージュのやさしさと濃厚さを、島外の人はどう感じるのだろう？それを確かめるべくTOKYO HEALTH CLUBとコラボレーション。TOKYO目線で、五島をイメージしたテーマソングをつくってくれました。五島への2泊3日の旅の様子をおさめたロードムービーともにお楽しみください。
        </p>
        <dl>
          <dt>TOKYO HEALTH CLUB トーキョーヘルスクラブ</dt>
          <dd>
            TSUBAME(DJ/BEATMAKER)、SIKK-O(MC)、JYAJIE(MC)、DULLBOY(MC)からなる多摩美術大学の同級生で結成された、3MC 1DJのHIP HOPグループ。2010年に活動を開始。2016年にManhattan Recordsから3rd Album『VIBRATION』をリリースし、よりその名を世に広める。2018年8月には自主ライブ企画を渋谷WWWで開催、チケットはソールドアウト、大盛況をおさめる。自主ライブ当日にリリースされたミニアルバム『NINGENDOG(会場限定版)』の先行シングル「HなGAL feat. Kick a Show」は、テレビ東京系『ゴッドタン』エンディングテーマに起用されている。現在は音楽だけではなく、美的センスや企画力などが評価され、さまざまな角度から注目を浴びるアーティストとなっている。 
          </dd>
        </dl>
        <img class="artistphoto" width="426" src="../assets/THC201804Atype01.jpg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YasashikuteBox',
}
</script>

<style scoped>
.flex-container{
  padding: 0 10px;
}
.main{
  max-width: 430px;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.13em;
  line-height: 1.8;
}
h2{
  font-size: 60px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-113%);
  display: inline-block;
}
.i2{
   transform: translateY(-103%);
}
.underLine{
  display: inline-block;
  border-bottom: 5px solid #000;
}
.main+.main{
  margin-top: 20px;
}
span.text{
  display: inline-block;
}
dl{
  max-width: 430px;
}
p{
  margin-bottom: 5px;
}
dl:before{
  content: "-----";
  margin-bottom: 20px;
  display: block;
}
dt{
  font-size: 14px;
  letter-spacing: 0.25em;
  margin-bottom: 28px;
}
dd{
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.13em;
  line-height: 1.8;
}
.flex-container{
  justify-content:center;
}
.flex-container{
  position: relative;
}
.flex-container + .flex-container{
  margin-top: 151px;
}
.yasashikute_item.text{
  min-width: 430px;
  margin-right: auto;
  padding: 0 10px;
  flex-basis: 50%;
}
.yasashikute_item.text.type2{
  margin-left: auto;
}
.yasashikute_item.text.type2 p,
.yasashikute_item.text.type2 dl,
.yasashikute_item.text.type2 img{
  display: block;
  margin-right: 0;
  margin-left: auto;
}
.yasashikute_item.illust{
  width: 614px;
  flex-basis: 50%;
  position: relative;
}
.yasashikute_item.illust.type2{
  text-align: left;
}
.yasashikute_item.illust.type2 h2{
  right: auto;
  left: 0;
}
.yasashikute_item.illust img{
  max-width:100%;
}

.yasashikute_item.illust img:nth-child{
  width: 614px;
  position: relative;
  right: -18px;
}
.yasashikute_item.illust.type2 img:nth-child{
  right: auto;
  left: -18px;
}
.yasashikute_item + .yasashikute_item{
  margin-left: 100px;
}
.yasashikute_item + .yasashikute_item.type2{
  margin-right: 100px;
  margin-left: 0;
}
.illustrationBy{
  margin-top: 80px;
}
.artistphoto{
  margin-top: 60px;
  margin-right: -14px;
}
.musicBox{
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width:100%;
  max-width:400px;
  text-align: center;
  font-weight: bold;
}
.musicBox:before{
  /*content: "試聴・DLはこちら";*/
  /*position: absolute;*/
  /*font-weight: bold;*/
  /*left: 0;*/
  /*top: -2em;*/
}
.musicBox > div{
  flex-basis: 150px;
}
.musicBox img{
  margin-top: 10px;
  width: 150px;
}

@media screen and (max-width:1396px){
  .yasashikute_item + .yasashikute_item{
    margin-left: 50px;
  }
  .yasashikute_item.illust{
    padding-left: 20px;
  }
  .yasashikute_item.illust.type2{
    padding-right: 20px;
  }
 .type2 .yasashikute_item + .yasashikute_item{
    margin-right: 50px;
  }
}
@media screen and (max-width:1010px){
  h2{
    font-size: 50px;
  }
}

@media screen and (max-width:940px){
  h2{
    position:static;
    transform: none !important;
    margin-bottom: 60px;
  }
  .flex-container{
    display: block;
    padding: 0 10px;
  }
  .yasashikute_item{
    width: 425px !important;
    margin: 0 auto !important;
    padding-left: 0;
  }
  .yasashikute_item.text{
    text-align: left !important;
    padding-right: 0;
  }
  .yasashikute_item.illust.type2{
    padding-right: 0;
  }
  .yasashikute_item.illust{
    padding-left: 0;
  }
  .yasashikute_item img{
    max-width: 100%;
  }
  .illustrationBy{
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .flex-container + .flex-container{
    margin-top: 50px;
  }
  .musicBox{
    position: relative;
    bottom: auto;
    margin: 0 auto 40px;
    padding-right: 0;
    width: 425px;
    font-size: 14px;
    justify-content: space-around;
  }
  .artistphoto{
    margin-right: 0;
  }
  .musicBox img{
    margin-top: 8px;
    width: 120px;
  }
}
@media screen and (max-width:510px){
  .yasashikute_item,
  .yasashikute_item.illust,
  .musicBox{
    padding: 0 10px !important;
    width: 100% !important;
    max-width: 425px;
  }
  .yasashikute_item.text{
    min-width: 0;
    padding: 0 10px !important;
  }
  .musicBox img
  .artistphoto img
  .yasashikute_item img{
    max-width: 100%;
  }
}
@media screen and (max-width:420px){
  h2{
    font-size: 25px;
  }
}
</style>
